import {BaseTextFieldProps} from "@mui/material";
import {StatusAprovacaoOrcamento} from "@models/solicitacoes/orcamento.ts";

export const statusOrcamentoColor = (status: StatusAprovacaoOrcamento): BaseTextFieldProps['color'] | 'inherit' => {
    const res = {
        'PendenteAprovador': 'warning',
        'Rejeitado': 'error',
        'Cancelado': 'error',
        'PendenteSolicitante': 'warning',
        'Pendente': 'warning',
        'Pendenterecurso': 'warning',
        'PendenteComprador': 'warning',
        'PendentePagamento': 'warning',
        'Finalizado': 'info',
        'PendenteRecurso': 'warning',
        'AguardandoEntrega': 'info',
    }[status] ?? 'inherit';

    return res as BaseTextFieldProps['color'] | 'inherit'
};